var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductPage',{attrs:{"theme":_vm.theme,"page-meta":_vm.pageMeta,"sections":_vm.sections,"features":_vm.features,"architecture":_vm.architecture,"why-us":_vm.whyUs,"scenarios":_vm.scenarios,"related-products":_vm.relatedProducts,"contact-path":"/smart-inspection","default-product":"智慧巡检系统"}})
}
var staticRenderFns = []

export { render, staticRenderFns }